import { PartialPatient } from "@/modules/DoctorProfile/models/AppointmentItem";

export class EventGeneralInfo {
  date?: string | number;
  duration!: number;
  campus!: string;
  responsables!: string | Array<string>;
  status!: string;
  suggestions!: string;
  serviceName!: string;
}

export class EventPatients {
  info!: EventGeneralInfo;
  patients!: Array<PartialPatient>;
}
